import React from "react";
import Home from "./pages"; ///< index.jsx will be automatically imported
import PublicMint from "./pages/publicmint";
import WhitelistMint from "./pages/whitelistmint";
import OgWhitelist from "./pages/ogwhitelist";

// Hash Router
import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";



export default function App() {

  return (
    <Router>
      <div>

        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL.
            <Route path="/mint">
              <Mint />
            </Route>*/}

        <Switch>


        <Route exact path="/mint" component={PublicMint} />
        <Route path="/" component={Home} />
        </Switch>
      </div>
    </Router>
  );
}

//<Route exact path="/public-mint" component={PublicMint} />
//<Route exact path="/og-whitelist" component={OgWhitelist} />
//<Route exact path="/whitelist-mint" component={WhitelistMint} />
